module.exports = __webpack_public_path__ + "static/media/SoumyajitPaul.dfe7b69c.png";